module.exports = __webpack_public_path__ + "static/media/schliffe_fragezeichen.c78644c9.jpg";